import { Injectable } from '@angular/core';
import { country } from '../enums/language';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root',
})
export class FormaterService {
  constructor(private languageService: LanguageService) {}

  formatNo(number, minFractionDigits: number | null = null) {
    // Return the original input if it's not a number.
    if (!number) return (number || 0).toString();

    const domain = this.languageService.getDomain();
    const isCountryMalaysia =
      this.languageService.getCountry() === country.ai.country;

    // Determine the minimum fraction digits to use.
    const minFraction =
      minFractionDigits !== null && isCountryMalaysia
        ? minFractionDigits
        : country[domain].minDecimal;

    // Format the number using the appropriate options.
    const formatOptions = {
      maximumFractionDigits: country[domain].maxDecimal,
      minimumFractionDigits: minFraction,
    };

    return new Intl.NumberFormat(
      country[domain].acceptLanguage,
      formatOptions
    ).format(number);
  }

  formatMy(stringNumber) {
    if (!stringNumber) return stringNumber;
    if (this.languageService.getCountry() === country.id.country) {
      stringNumber =
        typeof stringNumber === 'number'
          ? stringNumber.toString()
          : stringNumber;
      var thousandSeparator = Intl.NumberFormat('id')
        .format(11111)
        .replace(/1/g, '');
      var decimalSeparator = Intl.NumberFormat('id')
        .format(1.1)
        .replace(/1/g, '');

      return parseFloat(
        stringNumber
          .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
          .replace(new RegExp('\\' + decimalSeparator), '.')
      );
    } else {
      stringNumber =
        typeof stringNumber === 'number'
          ? stringNumber
          : parseFloat(stringNumber.replace(/,/g, ''));
      return stringNumber;
    }
  }

  formatInventoryNo(number) {
    if (!number) return number;
    let domain = this.languageService.getDomain();
    return new Intl.NumberFormat(country[domain].acceptLanguage).format(number);
  }

  formatAddonNo(number) {
    if (!number) return number;
    let numericNum = number;
    if (this.languageService.getCountry() === country.id.country) {
      numericNum = this.formatMy(numericNum);
    }
    let domain = this.languageService.getDomain();
    return new Intl.NumberFormat(country[domain].acceptLanguage, {
      maximumFractionDigits: country[domain].maxDecimal,
      minimumFractionDigits: country[domain].minDecimal,
    }).format(numericNum);
  }
}
